import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'superflex-buscar-btn',
    template: `
        <p-button
            label="{{'BOTONES.btnBuscar' | translate}}"
            [icon]="icon"
            [styleClass]="styleClass"
            [class]="class"
            [type]="'submit'"
            (onClick)="onClick.emit()"
            [disabled]="isDisabled">
        </p-button>`,
})
export class BuscarBtnComponent {

    @Input() isDisabled: boolean;
    @Input() icon = '';
    @Output() onClick = new EventEmitter<any>();
    @Input() styleClass = 'p-button-primary p-mr-2';
    @Input() class = '';

    constructor() {/***/}
}
